import get from 'lodash/get';
import * as types from './constants';

const mortgageDetailsInitialState = {
  startDate: '',
  endDate: '',
  mortgageAmount: null,
  mortgageTypeId: null,
  contractNumber: null,
  bankSignatoryId: null,
  valuationCompanyLicenseNumber: '',
  valuatorProfessionId: null,
  valuatorCompanyId: null,
  valuatorUserId: null,
};

const defaultState = {
  loading: false,
  error: null,
  currentStep: 0,
  application: {},
  paymentPlanType: '',
  instalmentPlanList: [],
  buyers: [],
  owners: [],
  broker: {},
  brokerDetails: {},
  contractDetails: {},
  sellingAmount: '',
  sellingDate: '',
  evaluationAmount: '',
  representativeDetails: [],
  documents: [],
  property: {},
  breakdown: {},
  sellerDetails: {},
  companiesResponse: {},
  usersResponse: {},
  currentBuyerDocuments: [],
  // --------------- previous work ------------- //
  applicationInitalData: {},
  totalSellingPercentage: 0,
  totalBuyingPercentage: 0,
  applicationId: null,
  applicationType: '',
  propertyDocuments: null,
  updatePercentbuyer: [],
  propertyDetails: null,

  // Mortgage Data
  mortgageDetails: mortgageDetailsInitialState,
  mortgageTypes: [],
  bankSignatories: [],
  valuationCompanies: [],
  valuators: [],
  dropDownsErrors: [],

  // ----------- Mortgage Shares -----------
  isSharedMortgage: false,
  mortgageShares: [],

  // ----------- Selling Shares -----------
  isSharedSelling: false,
  sellingShares: [],
  selectedPrimaryBuyerId: null,

  // ----------- Active Agreements -----------
  activeAgreements: [],
  appointmentType: null,
};

// eslint-disable-next-line consistent-return
export default function transferOfInterestReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.TRANSFER_OF_INTEREST_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.TRANSFER_OF_INTEREST_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.TRANSFER_OF_INTEREST_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action, 'payload', null),
      };
    case types.TRANSFER_OF_INTEREST_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    case types.TRANSFER_OF_INTEREST_CLEAR_APPLICATION:
      return {
        ...defaultState,
      };

    case types.TRANSFER_OF_INTEREST_FETCH_PROPERTY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        property: action.payload,
      };
    case types.TRANSFER_OF_INTEREST_SET_CONTRACT_DETAILS:
      return {
        ...state,
        contractDetails: { ...state.contractDetails, [action.payload.key]: action.payload.value },
      };
    case types.TRANSFER_OF_INTEREST_FETCH_APPLICATION_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', ''),
        paymentPlanType: get(action.payload, 'paymentPlanType', []),
        instalmentPlanList: get(action.payload, 'instalmentPlanList', []),
        Banklists: get(action.payload, 'Banklists', []),
        buyers: get(action.payload, 'buyers', []),
        owners: get(action.payload, 'owners', []),
        broker: get(action.payload, 'broker', {}),
        bankSignatories: get(action.payload, 'bankSignatories', []),
        valuationCompanies: get(action.payload, 'valuationCompanies', []),
        mortgageTypes: get(action.payload, 'mortgageTypes', []),
        mortgageDetails: get(action.payload, 'mortgageDetails', []),
        appointmentType: get(action.payload, 'appointmentType', []),
        contractDetails: get(action.payload, 'contractDetails', {}),
        representativeDetails: get(action.payload, 'representativeDetails', []),
        mortgageShares: get(action.payload, 'mortgageShares', []),
        isSharedMortgage: get(action.payload, 'isSharedMortgage', false),
        sellingShares: get(action.payload, 'sellingShares', []),
        isSharedSelling: get(action.payload, 'isSharedSelling', false),
        selectedPrimaryBuyerId: get(action.payload, 'selectedPrimaryBuyerId', null),
      };

    case types.TRANSFER_OF_INTEREST_DELETE_BROKER_SUCCESS: {
      return {
        ...state,
        loading: false,
        broker: {},
      };
    }

    case types.TRANSFER_OF_INTEREST_CLEAR_REDUCER:
      return defaultState;

    case types.TRANSFER_OF_INTEREST_ADD_BUYER_SUCCESS: {
      return {
        ...state,
        loading: false,
        documents: get(action.payload, 'documents', state.documents),
      };
    }

    case types.TRANSFER_OF_INTEREST_SET_BUYER_TRANSACTION_PERCENTAGE:
      const updatedBuyers = state?.buyers?.map(buyer => {
        if (
          (action?.data?.isUser && buyer?.id === action?.data?.id) ||
          (action?.data?.isCompany && buyer?.id === action?.data?.id)
        ) {
          return {
            ...buyer,
            transactionShare: action?.data?.transactionShare,
          };
        }

        return buyer;
      });
      return {
        ...state,
        buyers: updatedBuyers,
      };

    case types.TRANSFER_OF_INTEREST_SAVE_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.TRANSFER_OF_INTEREST_CHANGE_WORKFLOW_STEP:
      return {
        ...state,
        currentStep: get(action.payload, 'step'),
      };

    case types.TRANSFER_OF_INTEREST_FETCH_BREAKDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        breakdown: get(action.payload, 'breakdown', []),
      };
    case types.TRANSFER_OF_INTEREST_RESET_BREAKDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        breakdown: null,
      };
    case types.TRANSFER_OF_INTEREST_FETCH_DOCUMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };

    case types.TRANSFER_OF_INTEREST_FIELD_CHANGE:
      if (action.payload.object) {
        return {
          ...state,
          application: {
            ...state.application,
            [action.payload.object]: {
              ...state.application[action.payload.object],
              // [action.payload.name]: action.payload.value,
              ...action.payload.valueObject,
            },
          },
        };
      }
      break;
    case types.TRANSFER_OF_INTEREST_FORM_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case types.TRANSFER_OF_INTEREST_FETCH_GOVERNMENT_COMPANIES_SUCCESS:
      return {
        ...state,
        loading: false,
        companiesResponse: get(action.payload, 'companiesResponse', {}),
      };
    case types.TRANSFER_OF_INTEREST_CLEAR_GOVERNMENT_COMPANIES:
      return {
        ...state,
        companiesResponse: {},
      };
    case types.TRANSFER_OF_INTEREST_FETCH_NON_UAE_USERS:
      return {
        ...state,
        loading: true,
        usersResponse: {},
      };
    case types.TRANSFER_OF_INTEREST_FETCH_NON_UAE_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        usersResponse: get(action.payload, 'usersResponse', {}),
      };

    // --------------- previous work ------------- //

    case types.FETCH_APPLICATION_OFFPLAN:
      return {
        ...state,
        loading: true,
        application: null,
      };
    case types.FETCH_APPLICATION_OFFPLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.INITIATE_OFFPLAN_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.INITIATE_OFFPLAN_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.INITIATE_OFFPLAN_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SAVE_INSTALLMENT_PLAN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.SAVE_INSTALLMENT_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.SAVE_INSTALLMENT_PLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.DELETE_INSTALLMENT_PLAN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_INSTALLMENT_PLAN_SUCCESS:
      return {
        ...state,
        instalmentPlanList: [],
        loading: false,
        error: null,
      };
    case types.DELETE_INSTALLMENT_PLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.FETCH_OFFPLAN_BUYER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_OFFPLAN_BUYER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.FETCH_OFFPLAN_BUYER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.FETCH_OFFPLAN_PAYMENT_BREAKDOWN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_OFFPLAN_PAYMENT_BREAKDOWN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.DELETE_OFFPLAN_BUYER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_OFFPLAN_BUYER_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        brokers: get(action.payload, 'brokers', []),
      };
    }
    case types.DELETE_OFFPLAN_BUYER_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.FETCH_OFFPLAN_POA:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_OFFPLAN_POA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.FETCH_OFFPLAN_POA_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.ADD_OFFPLAN_POA:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.ADD_OFFPLAN_POA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        representativeDetails: get(action.payload, 'representativeDetails', []),
      };
    case types.ADD_OFFPLAN_POA_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.MUSATAHA_CHANGE_APPLICATION_STEP:
      return {
        ...state,
        currentStep: action?.payload,
      };
    case types.CHANGE_OFF_PLAN_STEP:
      return {
        ...state,
        currentStep: get(action.payload, 'step'),
      };
    case types.OFFPLAN_VALIDATION_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.UPLOAD_MUSATAHA_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPLOAD_MUSATAHA_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };
    case types.UPLOAD_MUSATAHA_DOCUMENT_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.DOWNLOAD_DOCUMENT_MUSATAHA:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_DOCUMENT_MUSATAHA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.DOWNLOAD_DOCUMENT_MUSATAHA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.ADD_TO_ERROR_INITITATE:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case types.ADD_TO_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SAVE_APPLICATION_OFFPLAN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.SAVE_APPLICATION_OFFPLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.MUSATAHA_CANCEL_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.MUSATAHA_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.MUSATAHA_CANCEL_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.UPDATE_SALE_DETAILS:
      return {
        ...state,
        application: {
          ...state.application,
          ...action.payload,
        },
      };
    case types.SET_BUYER_DETAIL:
      return {
        ...state,
        updatePercentbuyer: [...state.buyers],
      };

    case types.SET_IS_SHARED_MORTGAGE:
      return {
        ...state,
        isSharedMortgage: action.payload,
      };

    case types.SET_MORTGAGE_SHARES:
      return {
        ...state,
        mortgageShares: action.payload,
      };
    case types.RESET_MORTGAGE_SHARES:
      return {
        ...state,
        mortgageShares: [],
      };

    case types.SET_IS_SHARED_SELLING:
      return {
        ...state,
        isSharedSelling: action.payload,
      };

    case types.SET_SELLING_SHARES:
      return {
        ...state,
        sellingShares: action.payload,
      };
    case types.RESET_SELLING_SHARES:
      return {
        ...state,
        sellingShares: [],
      };

    case types.SHOW_VALIDATION_MESSAGE:
      return {
        ...state,
        error: action.payload,
      };

    case types.TRANSFER_OF_INTEREST_SET_MORTGAGE_BANK_MAKER_DETAILS:
      return {
        ...state,
        mortgageDetails: { ...state.mortgageDetails, [action.payload.key]: action.payload.value },
      };
    case types.FETCH_VALUATORS:
      return {
        ...state,
        loading: true,
        error: null,
        valuators: [],
      };
    case types.FETCH_VALUATORS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        valuators: get(action.payload, 'valuators', []),
      };
    case types.FETCH_VALUATORS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        valuators: [],
      };

    case types.SET_SELECTED_PRIMARY_BUYER_ID:
      return {
        ...state,
        selectedPrimaryBuyerId: action.payload,
      };

    case types.FETCH_ACTIVE_AGREEMENTS:
      return {
        ...state,
        loading: true,
        error: null,
        activeAgreements: [],
      };
    case types.FETCH_ACTIVE_AGREEMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        activeAgreements: action.payload,
      };
    case types.FETCH_ACTIVE_AGREEMENTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        activeAgreements: [],
      };
    case types.SET_ATTENDANCE_TYPE:
      return {
        ...state,
        appointmentType: action.payload?.appointmentType,
        application: {
          ...state.application,
          ...action.payload,
        },
      };

    default:
      return state;
  }
}
